import React from "react"
import { Route } from "react-router-dom"

export function PhoneSupportRouter({ path, component }: { path: string; component: React.FC }): JSX.Element {
  return <Route path={path} component={component} />
}
